var firebaseConfig = {
  apiKey: "AIzaSyArZXhtyZ7hqs_V27Z57WFgw1q0kE6gKic",
  authDomain: "todo-42eeb.firebaseapp.com",
  projectId: "todo-42eeb",
  storageBucket: "todo-42eeb.appspot.com",
  messagingSenderId: "253604663665",
  appId: "1:253604663665:web:e52cf1a69eca69bb0de6d0",
};
export default firebaseConfig;
